import { useMemo } from 'react'

const useSanitizedSlug = (path: string) => {
  const generateSlug = (path: string) => {
    let slug = path?.toLowerCase().replace(/[^a-z0-9/]+/g, '-') // Replace non-alphanumeric characters with '-'
    slug = slug?.replace(/^-+|-+$/g, '') // Remove leading and trailing hyphens
    slug = slug?.replace(/\/+/g, '/') // Replace multiple slashes with single slash
    return slug
  }

  return useMemo(() => generateSlug(path), [path])
}

export default useSanitizedSlug
